/**
 * @file       secureLayout component
 * @version    2.0.0
 * @author     Mehran Majidi
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or 
 *             altered in anyway without expressed written permission from 
 *             MindShare HDV LLC.
 */

import { CommonModule } from '@angular/common';

//import { NgModule } from '@angular/core';
//import { FormsModule } from '@angular/forms';
//import { ReactiveFormsModule } from '@angular/forms';

//import { MatSidenavModule } from '@angular/material/sidenav';
//import { MatListModule } from '@angular/material/list';


//import { MatButtonModule } from '@angular/material/button';
//import { MatIconModule } from '@angular/material/icon';
//import { MatToolbarModule } from '@angular/material/toolbar';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Subscription } from 'rxjs';

import { Component, OnDestroy, OnInit } from '@angular/core';

//import { Inject, ViewChild, ElementRef } from '@angular/core';


//import { Chart } from 'chart.js';
import { RouterModule } from '@angular/router';
import { MatDialogModule, MatDialog, MatDialogRef } from
         '@angular/material/dialog';
import { SecureHeaderComponent } from 
    '@app/secure/core/layout/secureHeader.component';
import { IdleTimeoutComponent } from 
    '@app/secure/core/timeout/idleTimeout.component';
import { AuthService } from '@app/service/auth.service';

@Component
({
    selector: 'app-secure-layout',
    templateUrl: './secureLayout.component.html',
    styleUrls: ['./secureLayout.component.scss'],
    imports:
    [
        CommonModule,
        RouterModule,
        MatDialogModule,
        SecureHeaderComponent
    ],
    standalone: true
})

class SecureLayoutComponent implements OnInit, OnDestroy
{
    idleState:string = 'Not started.';
    timedOut:boolean = false;
    lastPing?: Date = null;

    private readonly sessionIdleLimitSec:number = 3600;
    private readonly warningWindowSec:number = 10;
    private idleStartSec:number = 3590;
    private timeoutPeriodSec:number = 10;
    private idleSubscriptions: Subscription;
    private dialogRef : MatDialogRef<IdleTimeoutComponent>;

    public countdown: number;
    
    /**
     * @desc   - component constructor
     * @access - public
     * @param  - 
     * @return - 
     */            
    constructor
    (
        private authService: AuthService,
        private dialog: MatDialog,
//        private keepalive: Keepalive,
        private idle: Idle
    )
    {
        this.idleSubscriptions = new Subscription();
        this.dialogRef = null;

        this.timeoutPeriodSec = this.warningWindowSec;
        this.idleStartSec = this.sessionIdleLimitSec - this.warningWindowSec;
        this.countdown = this.timeoutPeriodSec;
    }

    /**
     * @desc   - angular initializer
     * @access - public
     * @param  - 
     * @return - 
     */            
    ngOnInit() 
    {
        this.configureIdleWatcher();
    }

    /**
     * @desc   - angular destroy lifecycle
     * @access - public
     * @param  -
     * @return -
     */
    ngOnDestroy()
    {
        if (this.dialogRef)
        {
            this.dialogRef.close();
            this.dialogRef = null;
        }

        this.idle.stop();
        this.idleSubscriptions.unsubscribe();
    }

    /**
     * @desc   - initialize idle watcher and warning hooks
     * @access - private
     * @param  -
     * @return -
     */
    private configureIdleWatcher
    (
    )
    {
        this.idle.setIdle(this.idleStartSec);
        this.idle.setTimeout(this.timeoutPeriodSec);
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idleSubscriptions.add(
            this.idle.onIdleEnd.subscribe(() =>
            {
                this.idleState = 'No longer idle.';
                this.reset();
            })
        );

        this.idleSubscriptions.add(
            this.idle.onIdleStart.subscribe(() =>
            {
                this.idleState = 'You\'ve gone idle!';
                this.countdown = this.timeoutPeriodSec;

                if (!this.dialogRef)
                {
                    this.dialogRef = this.dialog.open(
                        IdleTimeoutComponent,
                        {
                            panelClass: 'modal-lg',
                            data:
                            {
                                idleObj: this.idle,
                                timeout: this.timeoutPeriodSec
                            }
                        }
                    );
                }
            })
        );

        this.idleSubscriptions.add(
            this.idle.onTimeoutWarning.subscribe((countdown: number) =>
            {
                this.idleState =
                    'You will time out in ' + countdown + ' seconds!';
                this.countdown = countdown;
            })
        );

        this.idleSubscriptions.add(
            this.idle.onInterrupt.subscribe(() =>
            {
                if (this.dialogRef)
                {
                    this.closeMe();
                    this.reset();
                }
            })
        );

        this.idleSubscriptions.add(
            this.idle.onTimeout.subscribe(() =>
            {
                this.idleState = 'Timed out!';
                this.timedOut = true;

                if (this.dialogRef)
                {
                    this.dialogRef.close();
                    this.dialogRef = null;
                }

                this.idle.stop();
                this.authService.logout();
            })
        );

        this.reset();
    }

    reset() 
    {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
    } 

    /**
     * @desc   - close the dialog
     * @access - public
     * @param  - 
     * @return - 
     */                
    closeMe() 
    {
        if (this.dialogRef)
        {
            this.dialogRef.close();
            this.dialogRef = null;
        }
    }    

/*
    
      hideChildModal(): void 
      {
        this.childModal.hide();
      }

      stay() {
        this.childModal.hide();
        this.reset();
      }

      logout() {
        this.childModal.hide();
//        this.appService.setUserLoggedIn(false);
        this.router.navigate(['/']);
      }   
*/ 
}

export { SecureLayoutComponent }